module.exports = __webpack_public_path__ + "img/android-chrome-maskable-192x192.d39a7596.png";